import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const updatePackage = createAsyncThunk(
  "package/updatePackage",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const deliveryData = {
      package_id: data.package_id,
      driverID: data.driverID,
      customerID: data.customerID,
      pickup_address: data.pickup_address,
      dropoff_address: data.dropoff_address,
      order_date: data.order_date,
      order_time: data.order_time,
      pd_height: data.pd_height,
      pd_width: data.pd_width,
      pd_depth: data.pd_depth,
      pd_volume: data.pd_volume,
      status: data.status,
    };

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deliveryData),
    };

    try {
      const response = await fetch(`${apiUrl}/update_delivery`, requestOptions);

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Updating delivery failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
